function InProperty(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M11 17c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H7V9H5v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z" />
    </svg>
  )
}

export default InProperty
